import { componentQrl, inlinedQrl, useComputedQrl, useLexicalScope, _jsxS, _fnSignal } from "@builder.io/qwik";
import { isEditing } from "../../functions/is-editing.qwik.mjs";
import { getSrcSet } from "../image/image.helpers.qwik.mjs";
const ImgComponent = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const srcSetToUse = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    const url = props2.imgSrc || props2.image;
    if (!url || typeof url !== "string")
      return void 0;
    if (!url.match(/builder\.io/))
      return void 0;
    return getSrcSet(url);
  }, "ImgComponent_component_srcSetToUse_useComputed_z7PUtkds7Q0", [
    props
  ]));
  return /* @__PURE__ */ _jsxS("img", {
    ...props.attributes
  }, {
    alt: _fnSignal((p0) => p0.altText, [
      props
    ], "p0.altText"),
    loading: "lazy",
    src: _fnSignal((p0) => p0.imgSrc || p0.image, [
      props
    ], "p0.imgSrc||p0.image"),
    srcSet: _fnSignal((p0) => p0.value, [
      srcSetToUse
    ], "p0.value"),
    style: _fnSignal((p0) => ({
      objectFit: p0.backgroundSize || "cover",
      objectPosition: p0.backgroundPosition || "center"
    }), [
      props
    ], '{objectFit:p0.backgroundSize||"cover",objectPosition:p0.backgroundPosition||"center"}')
  }, 0, isEditing() && props.imgSrc || "default-key");
}, "ImgComponent_component_FXvIDBSffO8"));
export {
  ImgComponent,
  ImgComponent as default
};
